// 自动生成的模板数据
const templates = [
  {
    "id": "6746fe472f0052cb6a9365aa",
    "page": "template-1.html",
    "title": "双色标签经典简历模板",
    "seo": {
      "description": "双色标签经典简历模板 - 猫步简历提供的经典简历模板，助力您的求职之路",
      "keywords": "双色标签经典简历模板,经典简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1732705853233.png",
      "canonicalUrl": "https://maobucv.com/template/template-1.html"
    }
  },
  {
    "id": "674701372f0052cb6a93660b",
    "page": "template-2.html",
    "title": "深蓝两栏大气时尚简历模板",
    "seo": {
      "description": "深蓝两栏大气时尚简历模板 - 猫步简历提供的时尚简历模板，助力您的求职之路",
      "keywords": "深蓝两栏大气时尚简历模板,时尚简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template2-1732706612199.png",
      "canonicalUrl": "https://maobucv.com/template/template-2.html"
    }
  },
  {
    "id": "674704bd2f0052cb6a9366c5",
    "page": "template-3.html",
    "title": "简约轻快简历模板",
    "seo": {
      "description": "简约轻快简历模板 - 猫步简历提供的简洁简历模板，助力您的求职之路",
      "keywords": "简约轻快简历模板,简洁简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template3-1732707512348.png",
      "canonicalUrl": "https://maobucv.com/template/template-3.html"
    }
  },
  {
    "id": "674705f82f0052cb6a9366f9",
    "page": "template-4.html",
    "title": "曲线标签经典简历模板",
    "seo": {
      "description": "曲线标签经典简历模板 - 猫步简历提供的创意简历模板，助力您的求职之路",
      "keywords": "曲线标签经典简历模板,创意简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template4-1732707829789.png",
      "canonicalUrl": "https://maobucv.com/template/template-4.html"
    }
  },
  {
    "id": "674708c52f0052cb6a9367bb",
    "page": "template-5.html",
    "title": "双色典雅简洁简历模板",
    "seo": {
      "description": "双色典雅简洁简历模板 - 猫步简历提供的简洁简历模板，助力您的求职之路",
      "keywords": "双色典雅简洁简历模板,简洁简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template5-1732708546489.png",
      "canonicalUrl": "https://maobucv.com/template/template-5.html"
    }
  },
  {
    "id": "67470a292f0052cb6a936802",
    "page": "template-6.html",
    "title": "红色水印经典简历模板",
    "seo": {
      "description": "红色水印经典简历模板 - 猫步简历提供的经典简历模板，助力您的求职之路",
      "keywords": "红色水印经典简历模板,经典简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template6-1732708903897.png",
      "canonicalUrl": "https://maobucv.com/template/template-6.html"
    }
  },
  {
    "id": "67470cce2f0052cb6a936858",
    "page": "template-7.html",
    "title": "蓝色水印经典简历模板",
    "seo": {
      "description": "蓝色水印经典简历模板 - 猫步简历提供的经典简历模板，助力您的求职之路",
      "keywords": "蓝色水印经典简历模板,经典简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template7-1732709579142.png",
      "canonicalUrl": "https://maobucv.com/template/template-7.html"
    }
  },
  {
    "id": "67470f622f0052cb6a9368a7",
    "page": "template-8.html",
    "title": "灰色经典简历模板",
    "seo": {
      "description": "灰色经典简历模板 - 猫步简历提供的经典简历模板，助力您的求职之路",
      "keywords": "灰色经典简历模板,经典简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template8-1732710239116.png",
      "canonicalUrl": "https://maobucv.com/template/template-8.html"
    }
  },
  {
    "id": "674ef7a1499a3d6818e5f3e9",
    "page": "template-9.html",
    "title": "专业大气简洁简历模板",
    "seo": {
      "description": "专业大气简洁简历模板 - 猫步简历提供的简洁简历模板，助力您的求职之路",
      "keywords": "专业大气简洁简历模板,简洁简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template9-1733228442295.png",
      "canonicalUrl": "https://maobucv.com/template/template-9.html"
    }
  },
  {
    "id": "675038c5c016bbf823ea30eb",
    "page": "template-10.html",
    "title": "科技感创意简历模板",
    "seo": {
      "description": "科技感创意简历模板 - 猫步简历提供的创意简历模板，助力您的求职之路",
      "keywords": "科技感创意简历模板,创意简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template10-1733310656431.png",
      "canonicalUrl": "https://maobucv.com/template/template-10.html"
    }
  },
  {
    "id": "67503cd2c016bbf823ea3130",
    "page": "template-11.html",
    "title": "线条标签创意简历模板",
    "seo": {
      "description": "线条标签创意简历模板 - 猫步简历提供的创意简历模板，助力您的求职之路",
      "keywords": "线条标签创意简历模板,创意简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template11-1733311695983.png",
      "canonicalUrl": "https://maobucv.com/template/template-11.html"
    }
  },
  {
    "id": "67503de5c016bbf823ea317d",
    "page": "template-12.html",
    "title": "水墨中国风创意简历模板",
    "seo": {
      "description": "水墨中国风创意简历模板 - 猫步简历提供的创意简历模板，助力您的求职之路",
      "keywords": "水墨中国风创意简历模板,创意简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template12-1733311969880.png",
      "canonicalUrl": "https://maobucv.com/template/template-12.html"
    }
  },
  {
    "id": "67504062c016bbf823ea3228",
    "page": "template-13.html",
    "title": "线条标签创意简历模板",
    "seo": {
      "description": "线条标签创意简历模板 - 猫步简历提供的创意简历模板，助力您的求职之路",
      "keywords": "线条标签创意简历模板,创意简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template13-1733312599661.png",
      "canonicalUrl": "https://maobucv.com/template/template-13.html"
    }
  },
  {
    "id": "67505d9ac016bbf823ea3497",
    "page": "template-14.html",
    "title": "灰白黄时尚简历模板",
    "seo": {
      "description": "灰白黄时尚简历模板 - 猫步简历提供的时尚简历模板，助力您的求职之路",
      "keywords": "灰白黄时尚简历模板,时尚简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template14-1733320086716.png",
      "canonicalUrl": "https://maobucv.com/template/template-14.html"
    }
  },
  {
    "id": "67505e36c016bbf823ea34c0",
    "page": "template-15.html",
    "title": "左右两列时尚简历模板",
    "seo": {
      "description": "左右两列时尚简历模板 - 猫步简历提供的时尚简历模板，助力您的求职之路",
      "keywords": "左右两列时尚简历模板,时尚简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template15-1733320241792.png",
      "canonicalUrl": "https://maobucv.com/template/template-15.html"
    }
  },
  {
    "id": "6756f8ac8f0b47d968a0e98c",
    "page": "template-16.html",
    "title": "贸易买手社招简历模板",
    "seo": {
      "description": "贸易买手社招简历模板 - 猫步简历提供的经典简历模板，助力您的求职之路",
      "keywords": "贸易买手社招简历模板,经典简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template16-1733752995985.png",
      "canonicalUrl": "https://maobucv.com/template/template-16.html"
    }
  },
  {
    "id": "67584681ad08c962be2e9da4",
    "page": "template-17.html",
    "title": "会计优秀校招简历模板",
    "seo": {
      "description": "会计优秀校招简历模板 - 猫步简历提供的简洁简历模板，适合职能支持行业，适用于会计岗位，助力您的求职之路",
      "keywords": "会计优秀校招简历模板,简洁简历模板,职能支持简历,会计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template17-1733838459362.png",
      "canonicalUrl": "https://maobucv.com/template/template-17.html"
    }
  },
  {
    "id": "676015175e80d518fa0c1985",
    "page": "template-18.html",
    "title": "算法工程师内推简历模板",
    "seo": {
      "description": "算法工程师内推简历模板 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于后端开发岗位，助力您的求职之路",
      "keywords": "算法工程师内推简历模板,经典简历模板,互联网通信简历,后端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template18-1734350087227.png",
      "canonicalUrl": "https://maobucv.com/template/template-18.html"
    }
  },
  {
    "id": "676015735e80d518fa0c199b",
    "page": "template-19.html",
    "title": "算法工程师内推简历模板",
    "seo": {
      "description": "算法工程师内推简历模板 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于后端开发岗位，助力您的求职之路",
      "keywords": "算法工程师内推简历模板,经典简历模板,互联网通信简历,后端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template19-1734350181648.png",
      "canonicalUrl": "https://maobucv.com/template/template-19.html"
    }
  },
  {
    "id": "67615d45e4dde1f4d601c8c3",
    "page": "template-20.html",
    "title": "新媒体运营实习生简历模板",
    "seo": {
      "description": "新媒体运营实习生简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于新媒体运营岗位，助力您的求职之路",
      "keywords": "新媒体运营实习生简历模板,简洁简历模板,互联网通信简历,新媒体运营,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template21-1734435675320.png",
      "canonicalUrl": "https://maobucv.com/template/template-20.html"
    }
  },
  {
    "id": "6762cecba7abeb18adb74795",
    "page": "template-21.html",
    "title": "汽车设计工程师求职简历模板",
    "seo": {
      "description": "汽车设计工程师求职简历模板 - 猫步简历提供的经典简历模板，适合制造能源行业，适用于汽车设计岗位，助力您的求职之路",
      "keywords": "汽车设计工程师求职简历模板,经典简历模板,制造能源简历,汽车设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template22-1734528711262.png",
      "canonicalUrl": "https://maobucv.com/template/template-21.html"
    }
  },
  {
    "id": "6762cf7fa7abeb18adb747bb",
    "page": "template-22.html",
    "title": "汽车设计工程师求职简历模板",
    "seo": {
      "description": "汽车设计工程师求职简历模板 - 猫步简历提供的经典简历模板，适合制造能源行业，适用于汽车设计岗位，助力您的求职之路",
      "keywords": "汽车设计工程师求职简历模板,经典简历模板,制造能源简历,汽车设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template23-1734528890621.png",
      "canonicalUrl": "https://maobucv.com/template/template-22.html"
    }
  },
  {
    "id": "67694c8c163b51d356f05f00",
    "page": "template-23.html",
    "title": "汽车设计工程师求职简历模板",
    "seo": {
      "description": "汽车设计工程师求职简历模板 - 猫步简历提供的经典简历模板，适合制造能源行业，适用于汽车设计岗位，助力您的求职之路",
      "keywords": "汽车设计工程师求职简历模板,经典简历模板,制造能源简历,汽车设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template24-1734954117408.png",
      "canonicalUrl": "https://maobucv.com/template/template-23.html"
    }
  },
  {
    "id": "67694d83163b51d356f05f34",
    "page": "template-24.html",
    "title": "贸易买手社招简历模板",
    "seo": {
      "description": "贸易买手社招简历模板 - 猫步简历提供的经典简历模板，助力您的求职之路",
      "keywords": "贸易买手社招简历模板,经典简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template26-1734954448138.png",
      "canonicalUrl": "https://maobucv.com/template/template-24.html"
    }
  },
  {
    "id": "676952bb163b51d356f060e9",
    "page": "template-25.html",
    "title": "曲线标签经典简历模板",
    "seo": {
      "description": "曲线标签经典简历模板 - 猫步简历提供的创意简历模板，助力您的求职之路",
      "keywords": "曲线标签经典简历模板,创意简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template27-1734955697116.png",
      "canonicalUrl": "https://maobucv.com/template/template-25.html"
    }
  },
  {
    "id": "676d4a717017be6da0dfef21",
    "page": "template-26.html",
    "title": "交互设计实习生简历模板",
    "seo": {
      "description": "交互设计实习生简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于交互设计岗位，助力您的求职之路",
      "keywords": "交互设计实习生简历模板,简洁简历模板,互联网通信简历,交互设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template28-1735215936323.png",
      "canonicalUrl": "https://maobucv.com/template/template-26.html"
    }
  },
  {
    "id": "676d4b977017be6da0dfef72",
    "page": "template-27.html",
    "title": "交互设计实习生简历模板",
    "seo": {
      "description": "交互设计实习生简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于交互设计岗位，助力您的求职之路",
      "keywords": "交互设计实习生简历模板,简洁简历模板,互联网通信简历,交互设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template29-1735216020477.png",
      "canonicalUrl": "https://maobucv.com/template/template-27.html"
    }
  },
  {
    "id": "677d1d60a417ebf3598443b0",
    "page": "template-28.html",
    "title": "左右两列时尚简历模板",
    "seo": {
      "description": "左右两列时尚简历模板 - 猫步简历提供的时尚简历模板，助力您的求职之路",
      "keywords": "左右两列时尚简历模板,时尚简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template30-1736252855102.png",
      "canonicalUrl": "https://maobucv.com/template/template-28.html"
    }
  },
  {
    "id": "677d22169cfdfd2197ffe527",
    "page": "template-29.html",
    "title": "汽车设计工程师求职简历模板",
    "seo": {
      "description": "汽车设计工程师求职简历模板 - 猫步简历提供的经典简历模板，适合制造能源行业，适用于汽车设计岗位，助力您的求职之路",
      "keywords": "汽车设计工程师求职简历模板,经典简历模板,制造能源简历,汽车设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template31-1736253967804.png",
      "canonicalUrl": "https://maobucv.com/template/template-29.html"
    }
  },
  {
    "id": "677d2f56d1214dc3e579f697",
    "page": "template-30.html",
    "title": "汽车设计工程师求职简历模板",
    "seo": {
      "description": "汽车设计工程师求职简历模板 - 猫步简历提供的经典简历模板，适合制造能源行业，适用于汽车设计岗位，助力您的求职之路",
      "keywords": "汽车设计工程师求职简历模板,经典简历模板,制造能源简历,汽车设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template32-1736257343441.png",
      "canonicalUrl": "https://maobucv.com/template/template-30.html"
    }
  },
  {
    "id": "677e7bacfa61491bda1aa6db",
    "page": "template-31.html",
    "title": "平面设计师校招简历",
    "seo": {
      "description": "平面设计师校招简历 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于平面设计岗位，助力您的求职之路",
      "keywords": "平面设计师校招简历,经典简历模板,互联网通信简历,平面设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template33-1736342416086.png",
      "canonicalUrl": "https://maobucv.com/template/template-31.html"
    }
  },
  {
    "id": "677e7fedd1214dc3e57a2118",
    "page": "template-32.html",
    "title": "平面设计师校招简历",
    "seo": {
      "description": "平面设计师校招简历 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于平面设计岗位，助力您的求职之路",
      "keywords": "平面设计师校招简历,经典简历模板,互联网通信简历,平面设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template34-1736343530251.png",
      "canonicalUrl": "https://maobucv.com/template/template-32.html"
    }
  },
  {
    "id": "677e802dd1214dc3e57a2138",
    "page": "template-33.html",
    "title": "平面设计师校招简历",
    "seo": {
      "description": "平面设计师校招简历 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于平面设计岗位，助力您的求职之路",
      "keywords": "平面设计师校招简历,经典简历模板,互联网通信简历,平面设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template35-1736343591896.png",
      "canonicalUrl": "https://maobucv.com/template/template-33.html"
    }
  },
  {
    "id": "677e8076d1214dc3e57a2169",
    "page": "template-34.html",
    "title": "平面设计师校招简历",
    "seo": {
      "description": "平面设计师校招简历 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于平面设计岗位，助力您的求职之路",
      "keywords": "平面设计师校招简历,经典简历模板,互联网通信简历,平面设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template36-1736343667251.png",
      "canonicalUrl": "https://maobucv.com/template/template-34.html"
    }
  },
  {
    "id": "677fbe580a3df5adfa35ddeb",
    "page": "template-35.html",
    "title": "左右两列时尚简历模板",
    "seo": {
      "description": "左右两列时尚简历模板 - 猫步简历提供的时尚简历模板，助力您的求职之路",
      "keywords": "左右两列时尚简历模板,时尚简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template37-1736425010291.png",
      "canonicalUrl": "https://maobucv.com/template/template-35.html"
    }
  },
  {
    "id": "677fbeb30a3df5adfa35de35",
    "page": "template-36.html",
    "title": "左右两列时尚简历模板",
    "seo": {
      "description": "左右两列时尚简历模板 - 猫步简历提供的时尚简历模板，助力您的求职之路",
      "keywords": "左右两列时尚简历模板,时尚简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template38-1736425129377.png",
      "canonicalUrl": "https://maobucv.com/template/template-36.html"
    }
  },
  {
    "id": "677fbf4e0a3df5adfa35de73",
    "page": "template-37.html",
    "title": "左右两列时尚简历模板",
    "seo": {
      "description": "左右两列时尚简历模板 - 猫步简历提供的时尚简历模板，助力您的求职之路",
      "keywords": "左右两列时尚简历模板,时尚简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template39-1736425288975.png",
      "canonicalUrl": "https://maobucv.com/template/template-37.html"
    }
  },
  {
    "id": "6782485d0a3df5adfa361e5b",
    "page": "template-38.html",
    "title": "汽车设计工程师求职简历模板",
    "seo": {
      "description": "汽车设计工程师求职简历模板 - 猫步简历提供的经典简历模板，适合制造能源行业，适用于汽车设计岗位，助力您的求职之路",
      "keywords": "汽车设计工程师求职简历模板,经典简历模板,制造能源简历,汽车设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template40-1736591442453.png",
      "canonicalUrl": "https://maobucv.com/template/template-38.html"
    }
  },
  {
    "id": "6785176f0a3df5adfa367efe",
    "page": "template-39.html",
    "title": "平面设计师校招简历",
    "seo": {
      "description": "平面设计师校招简历 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于平面设计岗位，助力您的求职之路",
      "keywords": "平面设计师校招简历,经典简历模板,互联网通信简历,平面设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/templa-1736775525255.png",
      "canonicalUrl": "https://maobucv.com/template/template-39.html"
    }
  },
  {
    "id": "6787c0990a3df5adfa37071d",
    "page": "template-40.html",
    "title": "经典简洁简历模板",
    "seo": {
      "description": "经典简洁简历模板 - 猫步简历提供的简洁简历模板，助力您的求职之路",
      "keywords": "经典简洁简历模板,简洁简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1736949890999.png",
      "canonicalUrl": "https://maobucv.com/template/template-40.html"
    }
  },
  {
    "id": "67910176c4a87db755c1b46e",
    "page": "template-41.html",
    "title": "平面设计师校招简历",
    "seo": {
      "description": "平面设计师校招简历 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于平面设计岗位，助力您的求职之路",
      "keywords": "平面设计师校招简历,简洁简历模板,互联网通信简历,平面设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1737556334370.png",
      "canonicalUrl": "https://maobucv.com/template/template-41.html"
    }
  },
  {
    "id": "67910402c4a87db755c1b63f",
    "page": "template-42.html",
    "title": "经典标题栏简历模板",
    "seo": {
      "description": "经典标题栏简历模板 - 猫步简历提供的经典简历模板，助力您的求职之路",
      "keywords": "经典标题栏简历模板,经典简历模板,求职简历,简历,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template2-1737556977421.png",
      "canonicalUrl": "https://maobucv.com/template/template-42.html"
    }
  },
  {
    "id": "67a2109730d73be420ba4cff",
    "page": "template-43.html",
    "title": "新媒体运营实习生简历模板",
    "seo": {
      "description": "新媒体运营实习生简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于新媒体运营岗位，助力您的求职之路",
      "keywords": "新媒体运营实习生简历模板,简洁简历模板,互联网通信简历,新媒体运营,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template40-1738674319088.png",
      "canonicalUrl": "https://maobucv.com/template/template-43.html"
    }
  },
  {
    "id": "67ac824ad2ffbcb5d02e37be",
    "page": "template-44.html",
    "title": "电子信息工程考研复试简历",
    "seo": {
      "description": "电子信息工程考研复试简历 - 猫步简历提供的简洁简历模板，适合制造能源行业，适用于机械设计岗位，助力您的求职之路",
      "keywords": "电子信息工程考研复试简历,简洁简历模板,制造能源简历,机械设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739358773650.png",
      "canonicalUrl": "https://maobucv.com/template/template-44.html"
    }
  },
  {
    "id": "67ac8bc6d2ffbcb5d02e3882",
    "page": "template-45.html",
    "title": "电子信息工程考研复试简历",
    "seo": {
      "description": "电子信息工程考研复试简历 - 猫步简历提供的简洁简历模板，适合制造能源行业，适用于机械设计岗位，助力您的求职之路",
      "keywords": "电子信息工程考研复试简历,简洁简历模板,制造能源简历,机械设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739361216174.png",
      "canonicalUrl": "https://maobucv.com/template/template-45.html"
    }
  },
  {
    "id": "67addc863370f88ef9222659",
    "page": "template-46.html",
    "title": "互联网产品经理实习社招岗位通用模版",
    "seo": {
      "description": "互联网产品经理实习社招岗位通用模版 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于产品经理岗位，助力您的求职之路",
      "keywords": "互联网产品经理实习社招岗位通用模版,简洁简历模板,互联网通信简历,产品经理,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739446613272.png",
      "canonicalUrl": "https://maobucv.com/template/template-46.html"
    }
  },
  {
    "id": "67adde2d3370f88ef92227ef",
    "page": "template-47.html",
    "title": "平面设计师校招简历",
    "seo": {
      "description": "平面设计师校招简历 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于平面设计岗位，助力您的求职之路",
      "keywords": "平面设计师校招简历,经典简历模板,互联网通信简历,平面设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739447843937.png",
      "canonicalUrl": "https://maobucv.com/template/template-47.html"
    }
  },
  {
    "id": "67adde9b3370f88ef9222834",
    "page": "template-48.html",
    "title": "平面设计师校招简历",
    "seo": {
      "description": "平面设计师校招简历 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于平面设计岗位，助力您的求职之路",
      "keywords": "平面设计师校招简历,经典简历模板,互联网通信简历,平面设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739447958658.png",
      "canonicalUrl": "https://maobucv.com/template/template-48.html"
    }
  },
  {
    "id": "67addf2d3370f88ef922287b",
    "page": "template-49.html",
    "title": "平面设计师校招简历",
    "seo": {
      "description": "平面设计师校招简历 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于平面设计岗位，助力您的求职之路",
      "keywords": "平面设计师校招简历,经典简历模板,互联网通信简历,平面设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739448104683.png",
      "canonicalUrl": "https://maobucv.com/template/template-49.html"
    }
  },
  {
    "id": "67ade0273370f88ef9222918",
    "page": "template-50.html",
    "title": "平面设计师校招简历",
    "seo": {
      "description": "平面设计师校招简历 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于平面设计岗位，助力您的求职之路",
      "keywords": "平面设计师校招简历,经典简历模板,互联网通信简历,平面设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739448355075.png",
      "canonicalUrl": "https://maobucv.com/template/template-50.html"
    }
  },
  {
    "id": "67b33185e37f7fe9590912c2",
    "page": "template-51.html",
    "title": "本科心理医生岗位简历模版",
    "seo": {
      "description": "本科心理医生岗位简历模版 - 猫步简历提供的时尚简历模板，适合医疗制药行业，适用于心理医生岗位，助力您的求职之路",
      "keywords": "本科心理医生岗位简历模版,时尚简历模板,医疗制药简历,心理医生,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739796862840.png",
      "canonicalUrl": "https://maobucv.com/template/template-51.html"
    }
  },
  {
    "id": "67b331d9e37f7fe9590912dc",
    "page": "template-52.html",
    "title": "本科心理医生岗位简历模版",
    "seo": {
      "description": "本科心理医生岗位简历模版 - 猫步简历提供的时尚简历模板，适合医疗制药行业，适用于心理医生岗位，助力您的求职之路",
      "keywords": "本科心理医生岗位简历模版,时尚简历模板,医疗制药简历,心理医生,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739796947617.png",
      "canonicalUrl": "https://maobucv.com/template/template-52.html"
    }
  },
  {
    "id": "67b332f0e37f7fe9590912f6",
    "page": "template-53.html",
    "title": "本科心理医生岗位简历模版",
    "seo": {
      "description": "本科心理医生岗位简历模版 - 猫步简历提供的时尚简历模板，适合医疗制药行业，适用于心理医生岗位，助力您的求职之路",
      "keywords": "本科心理医生岗位简历模版,时尚简历模板,医疗制药简历,心理医生,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739797229378.png",
      "canonicalUrl": "https://maobucv.com/template/template-53.html"
    }
  },
  {
    "id": "67b333a7e37f7fe959091310",
    "page": "template-54.html",
    "title": "本科心理医生岗位简历模版",
    "seo": {
      "description": "本科心理医生岗位简历模版 - 猫步简历提供的时尚简历模板，适合医疗制药行业，适用于心理医生岗位，助力您的求职之路",
      "keywords": "本科心理医生岗位简历模版,时尚简历模板,医疗制药简历,心理医生,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739797408107.png",
      "canonicalUrl": "https://maobucv.com/template/template-54.html"
    }
  },
  {
    "id": "67b334f2e37f7fe95909132a",
    "page": "template-55.html",
    "title": "本科心理医生岗位简历模版",
    "seo": {
      "description": "本科心理医生岗位简历模版 - 猫步简历提供的时尚简历模板，适合医疗制药行业，适用于心理医生岗位，助力您的求职之路",
      "keywords": "本科心理医生岗位简历模版,时尚简历模板,医疗制药简历,心理医生,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739797728623.png",
      "canonicalUrl": "https://maobucv.com/template/template-55.html"
    }
  },
  {
    "id": "67b491443370f88ef925025d",
    "page": "template-56.html",
    "title": "内容运营校招岗位简历模板",
    "seo": {
      "description": "内容运营校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于内容运营岗位，助力您的求职之路",
      "keywords": "内容运营校招岗位简历模板,简洁简历模板,互联网通信简历,内容运营,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739886909419.png",
      "canonicalUrl": "https://maobucv.com/template/template-56.html"
    }
  },
  {
    "id": "67b4919b3370f88ef92502e1",
    "page": "template-57.html",
    "title": "内容运营校招岗位简历模板",
    "seo": {
      "description": "内容运营校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于内容运营岗位，助力您的求职之路",
      "keywords": "内容运营校招岗位简历模板,简洁简历模板,互联网通信简历,内容运营,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739886997070.png",
      "canonicalUrl": "https://maobucv.com/template/template-57.html"
    }
  },
  {
    "id": "67b492443370f88ef925039a",
    "page": "template-58.html",
    "title": "内容运营校招岗位简历模板",
    "seo": {
      "description": "内容运营校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于内容运营岗位，助力您的求职之路",
      "keywords": "内容运营校招岗位简历模板,简洁简历模板,互联网通信简历,内容运营,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739887164685.png",
      "canonicalUrl": "https://maobucv.com/template/template-58.html"
    }
  },
  {
    "id": "67b5df443370f88ef92589dc",
    "page": "template-59.html",
    "title": "内容运营校招岗位简历模板",
    "seo": {
      "description": "内容运营校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于内容运营岗位，助力您的求职之路",
      "keywords": "内容运营校招岗位简历模板,简洁简历模板,互联网通信简历,内容运营,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739972406148.png",
      "canonicalUrl": "https://maobucv.com/template/template-59.html"
    }
  },
  {
    "id": "67b5e1793370f88ef9258aa6",
    "page": "template-60.html",
    "title": "Java开发工程师校招岗位简历模板",
    "seo": {
      "description": "Java开发工程师校招岗位简历模板 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于后端开发岗位，助力您的求职之路",
      "keywords": "Java开发工程师校招岗位简历模板,经典简历模板,互联网通信简历,后端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739972974257.png",
      "canonicalUrl": "https://maobucv.com/template/template-60.html"
    }
  },
  {
    "id": "67b5e2013370f88ef9258ae5",
    "page": "template-61.html",
    "title": "Java开发工程师校招岗位简历模板",
    "seo": {
      "description": "Java开发工程师校招岗位简历模板 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于后端开发岗位，助力您的求职之路",
      "keywords": "Java开发工程师校招岗位简历模板,经典简历模板,互联网通信简历,后端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739973114968.png",
      "canonicalUrl": "https://maobucv.com/template/template-61.html"
    }
  },
  {
    "id": "67b5e3343370f88ef9258b06",
    "page": "template-62.html",
    "title": "Java开发工程师校招岗位简历模板",
    "seo": {
      "description": "Java开发工程师校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于后端开发岗位，助力您的求职之路",
      "keywords": "Java开发工程师校招岗位简历模板,简洁简历模板,互联网通信简历,后端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739973419084.png",
      "canonicalUrl": "https://maobucv.com/template/template-62.html"
    }
  },
  {
    "id": "67b5e65b3370f88ef9258c93",
    "page": "template-63.html",
    "title": "校招Web前端开发工程师岗位简历模板",
    "seo": {
      "description": "校招Web前端开发工程师岗位简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于前端开发岗位，助力您的求职之路",
      "keywords": "校招Web前端开发工程师岗位简历模板,简洁简历模板,互联网通信简历,前端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739974230102.png",
      "canonicalUrl": "https://maobucv.com/template/template-63.html"
    }
  },
  {
    "id": "67b5e69d3370f88ef9258cd1",
    "page": "template-64.html",
    "title": "校招Web前端开发工程师岗位简历模板",
    "seo": {
      "description": "校招Web前端开发工程师岗位简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于前端开发岗位，助力您的求职之路",
      "keywords": "校招Web前端开发工程师岗位简历模板,简洁简历模板,互联网通信简历,前端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739974297043.png",
      "canonicalUrl": "https://maobucv.com/template/template-64.html"
    }
  },
  {
    "id": "67b5e6e33370f88ef9258d10",
    "page": "template-65.html",
    "title": "校招Web前端开发工程师岗位简历模板",
    "seo": {
      "description": "校招Web前端开发工程师岗位简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于前端开发岗位，助力您的求职之路",
      "keywords": "校招Web前端开发工程师岗位简历模板,简洁简历模板,互联网通信简历,前端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739974369232.png",
      "canonicalUrl": "https://maobucv.com/template/template-65.html"
    }
  },
  {
    "id": "67b5e80d3370f88ef9258d8d",
    "page": "template-66.html",
    "title": "校招Web前端开发工程师岗位简历模板",
    "seo": {
      "description": "校招Web前端开发工程师岗位简历模板 - 猫步简历提供的创意简历模板，适合互联网通信行业，适用于前端开发岗位，助力您的求职之路",
      "keywords": "校招Web前端开发工程师岗位简历模板,创意简历模板,互联网通信简历,前端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739974665117.png",
      "canonicalUrl": "https://maobucv.com/template/template-66.html"
    }
  },
  {
    "id": "67b5ea223370f88ef9258e10",
    "page": "template-67.html",
    "title": "校招Web前端开发工程师岗位简历模板",
    "seo": {
      "description": "校招Web前端开发工程师岗位简历模板 - 猫步简历提供的创意简历模板，适合互联网通信行业，适用于前端开发岗位，助力您的求职之路",
      "keywords": "校招Web前端开发工程师岗位简历模板,创意简历模板,互联网通信简历,前端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739975195228.png",
      "canonicalUrl": "https://maobucv.com/template/template-67.html"
    }
  },
  {
    "id": "67b5eaec3370f88ef9258e84",
    "page": "template-68.html",
    "title": "校招Web前端开发工程师岗位简历模板",
    "seo": {
      "description": "校招Web前端开发工程师岗位简历模板 - 猫步简历提供的创意简历模板，适合互联网通信行业，适用于前端开发岗位，助力您的求职之路",
      "keywords": "校招Web前端开发工程师岗位简历模板,创意简历模板,互联网通信简历,前端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739975387196.png",
      "canonicalUrl": "https://maobucv.com/template/template-68.html"
    }
  },
  {
    "id": "67b5eb423370f88ef9258f6c",
    "page": "template-69.html",
    "title": "校招Web前端开发工程师岗位简历模板",
    "seo": {
      "description": "校招Web前端开发工程师岗位简历模板 - 猫步简历提供的创意简历模板，适合互联网通信行业，适用于前端开发岗位，助力您的求职之路",
      "keywords": "校招Web前端开发工程师岗位简历模板,创意简历模板,互联网通信简历,前端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1739975484243.png",
      "canonicalUrl": "https://maobucv.com/template/template-69.html"
    }
  },
  {
    "id": "67b731da3370f88ef92600a5",
    "page": "template-70.html",
    "title": "广告设置校招岗位简历模板",
    "seo": {
      "description": "广告设置校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合广告传媒行业，适用于广告设计岗位，助力您的求职之路",
      "keywords": "广告设置校招岗位简历模板,简洁简历模板,广告传媒简历,广告设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1740059093675.png",
      "canonicalUrl": "https://maobucv.com/template/template-70.html"
    }
  },
  {
    "id": "67b732843370f88ef9260127",
    "page": "template-71.html",
    "title": "广告设置校招岗位简历模板",
    "seo": {
      "description": "广告设置校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合广告传媒行业，适用于广告设计岗位，助力您的求职之路",
      "keywords": "广告设置校招岗位简历模板,简洁简历模板,广告传媒简历,广告设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1740059260366.png",
      "canonicalUrl": "https://maobucv.com/template/template-71.html"
    }
  },
  {
    "id": "67b733473370f88ef9260187",
    "page": "template-72.html",
    "title": "广告设置校招岗位简历模板",
    "seo": {
      "description": "广告设置校招岗位简历模板 - 猫步简历提供的经典简历模板，适合广告传媒行业，适用于广告设计岗位，助力您的求职之路",
      "keywords": "广告设置校招岗位简历模板,经典简历模板,广告传媒简历,广告设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1740059455374.png",
      "canonicalUrl": "https://maobucv.com/template/template-72.html"
    }
  },
  {
    "id": "67b733f63370f88ef926024f",
    "page": "template-73.html",
    "title": "广告设置校招岗位简历模板",
    "seo": {
      "description": "广告设置校招岗位简历模板 - 猫步简历提供的创意简历模板，适合广告传媒行业，适用于广告设计岗位，助力您的求职之路",
      "keywords": "广告设置校招岗位简历模板,创意简历模板,广告传媒简历,广告设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1740059631568.png",
      "canonicalUrl": "https://maobucv.com/template/template-73.html"
    }
  },
  {
    "id": "67c5c015d202145b419d9841",
    "page": "template-74.html",
    "title": "测试工程师校招岗位简历模板",
    "seo": {
      "description": "测试工程师校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于测试岗位，助力您的求职之路",
      "keywords": "测试工程师校招岗位简历模板,简洁简历模板,互联网通信简历,测试,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1741013007815.png",
      "canonicalUrl": "https://maobucv.com/template/template-74.html"
    }
  },
  {
    "id": "67c5c087d202145b419d9868",
    "page": "template-75.html",
    "title": "测试工程师校招岗位简历模板",
    "seo": {
      "description": "测试工程师校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于测试岗位，助力您的求职之路",
      "keywords": "测试工程师校招岗位简历模板,简洁简历模板,互联网通信简历,测试,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1741013120734.png",
      "canonicalUrl": "https://maobucv.com/template/template-75.html"
    }
  },
  {
    "id": "67c5c111d202145b419d98da",
    "page": "template-76.html",
    "title": "测试工程师校招岗位简历模板",
    "seo": {
      "description": "测试工程师校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于测试岗位，助力您的求职之路",
      "keywords": "测试工程师校招岗位简历模板,简洁简历模板,互联网通信简历,测试,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1741013258631.png",
      "canonicalUrl": "https://maobucv.com/template/template-76.html"
    }
  },
  {
    "id": "67ed0e6d2852fb10a110ecff",
    "page": "template-77.html",
    "title": "社招高级前端开发工程师岗位简历模板",
    "seo": {
      "description": "社招高级前端开发工程师岗位简历模板 - 猫步简历提供的创意简历模板，适合互联网通信行业，适用于前端开发岗位，助力您的求职之路",
      "keywords": "社招高级前端开发工程师岗位简历模板,创意简历模板,互联网通信简历,前端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template10-1743588966861.png",
      "canonicalUrl": "https://maobucv.com/template/template-77.html"
    }
  },
  {
    "id": "67ed305a2852fb10a1110cb8",
    "page": "template-78.html",
    "title": "校招护士岗位简历模板",
    "seo": {
      "description": "校招护士岗位简历模板 - 猫步简历提供的简洁简历模板，适合医疗制药行业，适用于护士岗位，助力您的求职之路",
      "keywords": "校招护士岗位简历模板,简洁简历模板,医疗制药简历,护士,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1743597638487.png",
      "canonicalUrl": "https://maobucv.com/template/template-78.html"
    }
  },
  {
    "id": "67f7b3a0fd1c12e4a6db32ec",
    "page": "template-79.html",
    "title": "产品经理校招岗位简历模板",
    "seo": {
      "description": "产品经理校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于产品经理岗位，助力您的求职之路",
      "keywords": "产品经理校招岗位简历模板,简洁简历模板,互联网通信简历,产品经理,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1744286612711.png",
      "canonicalUrl": "https://maobucv.com/template/template-79.html"
    }
  },
  {
    "id": "67f7b86bfd1c12e4a6db34ea",
    "page": "template-80.html",
    "title": "产品经理校招岗位简历模板",
    "seo": {
      "description": "产品经理校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合房地产建筑行业，适用于测绘工程师岗位，助力您的求职之路",
      "keywords": "产品经理校招岗位简历模板,简洁简历模板,房地产建筑简历,测绘工程师,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1744287845815.png",
      "canonicalUrl": "https://maobucv.com/template/template-80.html"
    }
  },
  {
    "id": "67fd12f5fd1c12e4a6dd2d2a",
    "page": "template-81.html",
    "title": "银行柜员校招岗位简历模板",
    "seo": {
      "description": "银行柜员校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合金融投资行业，适用于银行柜员岗位，助力您的求职之路",
      "keywords": "银行柜员校招岗位简历模板,简洁简历模板,金融投资简历,银行柜员,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1744638700813.png",
      "canonicalUrl": "https://maobucv.com/template/template-81.html"
    }
  },
  {
    "id": "67ff99a7b342214936b9bc73",
    "page": "template-82.html",
    "title": "社招导游岗位简历模版",
    "seo": {
      "description": "社招导游岗位简历模版 - 猫步简历提供的经典简历模板，适合休闲服务行业，适用于导游岗位，助力您的求职之路",
      "keywords": "社招导游岗位简历模版,经典简历模板,休闲服务简历,导游,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1744804258820.png",
      "canonicalUrl": "https://maobucv.com/template/template-82.html"
    }
  },
  {
    "id": "6800dfee0d0ae6de78d77e93",
    "page": "template-83.html",
    "title": "健身教练简历模板",
    "seo": {
      "description": "健身教练简历模板 - 猫步简历提供的简洁简历模板，适合休闲服务行业，适用于健身教练岗位，助力您的求职之路",
      "keywords": "健身教练简历模板,简洁简历模板,休闲服务简历,健身教练,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1744887778011.png",
      "canonicalUrl": "https://maobucv.com/template/template-83.html"
    }
  },
  {
    "id": "6808d880d95401c9f30bdc7c",
    "page": "template-84.html",
    "title": "精算师实习岗位通用模版",
    "seo": {
      "description": "精算师实习岗位通用模版 - 猫步简历提供的简洁简历模板，适合金融投资行业，适用于精算师岗位，助力您的求职之路",
      "keywords": "精算师实习岗位通用模版,简洁简历模板,金融投资简历,精算师,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1745410169227.png",
      "canonicalUrl": "https://maobucv.com/template/template-84.html"
    }
  },
  {
    "id": "6808da7ad95401c9f30bde21",
    "page": "template-85.html",
    "title": "精算师实习岗位通用模版",
    "seo": {
      "description": "精算师实习岗位通用模版 - 猫步简历提供的简洁简历模板，适合金融投资行业，适用于精算师岗位，助力您的求职之路",
      "keywords": "精算师实习岗位通用模版,简洁简历模板,金融投资简历,精算师,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1745410675274.png",
      "canonicalUrl": "https://maobucv.com/template/template-85.html"
    }
  },
  {
    "id": "6810d0b3d95401c9f30f1762",
    "page": "template-86.html",
    "title": "灯光师简历模板",
    "seo": {
      "description": "灯光师简历模板 - 猫步简历提供的创意简历模板，适合广告传媒行业，适用于灯光师岗位，助力您的求职之路",
      "keywords": "灯光师简历模板,创意简历模板,广告传媒简历,灯光师,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1745932460809.png",
      "canonicalUrl": "https://maobucv.com/template/template-86.html"
    }
  },
  {
    "id": "681a0b21f47393a8bdd0f824",
    "page": "template-87.html",
    "title": "室内设计师校招岗位简历模板",
    "seo": {
      "description": "室内设计师校招岗位简历模板 - 猫步简历提供的简洁简历模板，适合房地产建筑行业，适用于室内设计岗位，助力您的求职之路",
      "keywords": "室内设计师校招岗位简历模板,简洁简历模板,房地产建筑简历,室内设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1746537242923.png",
      "canonicalUrl": "https://maobucv.com/template/template-87.html"
    }
  },
  {
    "id": "68346f67972b4210e0ddf81d",
    "page": "template-88.html",
    "title": "全栈工程师校招岗位简历模板",
    "seo": {
      "description": "全栈工程师校招岗位简历模板 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于后端开发岗位，助力您的求职之路",
      "keywords": "全栈工程师校招岗位简历模板,经典简历模板,互联网通信简历,后端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1748266850290.png",
      "canonicalUrl": "https://maobucv.com/template/template-88.html"
    }
  },
  {
    "id": "683ec8bc7f544115fad59041",
    "page": "template-89.html",
    "title": "材料工程师内推简历模板",
    "seo": {
      "description": "材料工程师内推简历模板 - 猫步简历提供的经典简历模板，适合制造能源行业，适用于材料工程师岗位，助力您的求职之路",
      "keywords": "材料工程师内推简历模板,经典简历模板,制造能源简历,材料工程师,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1748945076803.png",
      "canonicalUrl": "https://maobucv.com/template/template-89.html"
    }
  },
  {
    "id": "683f09e97f544115fad5c34c",
    "page": "template-90.html",
    "title": "电商运营岗位简历模板",
    "seo": {
      "description": "电商运营岗位简历模板 - 猫步简历提供的创意简历模板，适合互联网通信行业，适用于电商运营岗位，助力您的求职之路",
      "keywords": "电商运营岗位简历模板,创意简历模板,互联网通信简历,电商运营,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1748961753455.png",
      "canonicalUrl": "https://maobucv.com/template/template-90.html"
    }
  },
  {
    "id": "68404c1e7f544115fad65b69",
    "page": "template-91.html",
    "title": "音乐留学生简历模板",
    "seo": {
      "description": "音乐留学生简历模板 - 猫步简历提供的经典简历模板，适合教育培训行业，适用于音乐老师岗位，助力您的求职之路",
      "keywords": "音乐留学生简历模板,经典简历模板,教育培训简历,音乐老师,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1749044249456.png",
      "canonicalUrl": "https://maobucv.com/template/template-91.html"
    }
  },
  {
    "id": "68483b84db9a6f42d1728f81",
    "page": "template-92.html",
    "title": "文员校招岗位模版",
    "seo": {
      "description": "文员校招岗位模版 - 猫步简历提供的简洁简历模板，适合职能支持行业，适用于文员岗位，助力您的求职之路",
      "keywords": "文员校招岗位模版,简洁简历模板,职能支持简历,文员,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1749564276739.png",
      "canonicalUrl": "https://maobucv.com/template/template-92.html"
    }
  },
  {
    "id": "684ad199db9a6f42d17426a8",
    "page": "template-93.html",
    "title": "应届测试工程师岗位简历模板",
    "seo": {
      "description": "应届测试工程师岗位简历模板 - 猫步简历提供的简洁简历模板，适合互联网通信行业，适用于测试岗位，助力您的求职之路",
      "keywords": "应届测试工程师岗位简历模板,简洁简历模板,互联网通信简历,测试,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1749733770490.png",
      "canonicalUrl": "https://maobucv.com/template/template-93.html"
    }
  },
  {
    "id": "684d291ca230b232d4aa3cec",
    "page": "template-94.html",
    "title": "校招外贸专员简历模板",
    "seo": {
      "description": "校招外贸专员简历模板 - 猫步简历提供的经典简历模板，适合消费运输行业，适用于外贸专员岗位，助力您的求职之路",
      "keywords": "校招外贸专员简历模板,经典简历模板,消费运输简历,外贸专员,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1749887253803.png",
      "canonicalUrl": "https://maobucv.com/template/template-94.html"
    }
  },
  {
    "id": "684d50ab2fd66a7f7c0e91d4",
    "page": "template-95.html",
    "title": "社招广告设计师简历模板",
    "seo": {
      "description": "社招广告设计师简历模板 - 猫步简历提供的经典简历模板，适合广告传媒行业，适用于广告设计岗位，助力您的求职之路",
      "keywords": "社招广告设计师简历模板,经典简历模板,广告传媒简历,广告设计,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1749897370405.png",
      "canonicalUrl": "https://maobucv.com/template/template-95.html"
    }
  },
  {
    "id": "684ff6f12fd66a7f7c0ffadb",
    "page": "template-96.html",
    "title": "校招饲养员简历",
    "seo": {
      "description": "校招饲养员简历 - 猫步简历提供的经典简历模板，适合公共事业行业，适用于饲养员岗位，助力您的求职之路",
      "keywords": "校招饲养员简历,经典简历模板,公共事业简历,饲养员,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1750071012588.png",
      "canonicalUrl": "https://maobucv.com/template/template-96.html"
    }
  },
  {
    "id": "684ff9ec2fd66a7f7c0ffda6",
    "page": "template-97.html",
    "title": "校招硬件开发工程师简历",
    "seo": {
      "description": "校招硬件开发工程师简历 - 猫步简历提供的创意简历模板，适合互联网通信行业，适用于硬件开发岗位，助力您的求职之路",
      "keywords": "校招硬件开发工程师简历,创意简历模板,互联网通信简历,硬件开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1750071777540.png",
      "canonicalUrl": "https://maobucv.com/template/template-97.html"
    }
  },
  {
    "id": "68540554655b0f83934283d1",
    "page": "template-98.html",
    "title": "5年经验项目管理简历模版",
    "seo": {
      "description": "5年经验项目管理简历模版 - 猫步简历提供的创意简历模板，适合互联网通信行业，适用于项目管理岗位，助力您的求职之路",
      "keywords": "5年经验项目管理简历模版,创意简历模板,互联网通信简历,项目管理,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1750336840054.png",
      "canonicalUrl": "https://maobucv.com/template/template-98.html"
    }
  },
  {
    "id": "685640f4a9111428a8341e4f",
    "page": "template-99.html",
    "title": "资深文案策划简历模版",
    "seo": {
      "description": "资深文案策划简历模版 - 猫步简历提供的经典简历模板，适合广告传媒行业，适用于文案策划岗位，助力您的求职之路",
      "keywords": "资深文案策划简历模版,经典简历模板,广告传媒简历,文案策划,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1750483183939.png",
      "canonicalUrl": "https://maobucv.com/template/template-99.html"
    }
  },
  {
    "id": "68593fb4a9111428a8357fdb",
    "page": "template-100.html",
    "title": "5年高级前端工程师简历模版",
    "seo": {
      "description": "5年高级前端工程师简历模版 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于前端开发岗位，助力您的求职之路",
      "keywords": "5年高级前端工程师简历模版,经典简历模板,互联网通信简历,前端开发,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/Snipaste_2025-06-23_19-50-02-1750679468852.png",
      "canonicalUrl": "https://maobucv.com/template/template-100.html"
    }
  },
  {
    "id": "685beff872f02ccaaf0ded93",
    "page": "template-101.html",
    "title": "5年高中语文教师简历模版",
    "seo": {
      "description": "5年高中语文教师简历模版 - 猫步简历提供的经典简历模板，适合教育培训行业，适用于语文老师岗位，助力您的求职之路",
      "keywords": "5年高中语文教师简历模版,经典简历模板,教育培训简历,语文老师,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1750855871423.png",
      "canonicalUrl": "https://maobucv.com/template/template-101.html"
    }
  },
  {
    "id": "6862657172f02ccaaf11fd8a",
    "page": "template-102.html",
    "title": "电商运营应届生简历模版",
    "seo": {
      "description": "电商运营应届生简历模版 - 猫步简历提供的时尚简历模板，适合互联网通信行业，适用于电商运营岗位，助力您的求职之路",
      "keywords": "电商运营应届生简历模版,时尚简历模板,互联网通信简历,电商运营,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/Snipaste_2025-06-30_18-21-18-1751278951752.png",
      "canonicalUrl": "https://maobucv.com/template/template-102.html"
    }
  },
  {
    "id": "68668dca34bc6a824d2fbab5",
    "page": "template-103.html",
    "title": "校招质检员简历模版",
    "seo": {
      "description": "校招质检员简历模版 - 猫步简历提供的创意简历模板，适合消费运输行业，适用于质检岗位，助力您的求职之路",
      "keywords": "校招质检员简历模版,创意简历模板,消费运输简历,质检,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/Snipaste_2025-07-03_22-02-22-1751551425472.png",
      "canonicalUrl": "https://maobucv.com/template/template-103.html"
    }
  },
  {
    "id": "6880c88c20e3189056304800",
    "page": "template-104.html",
    "title": "文案策划应届生简历模版",
    "seo": {
      "description": "文案策划应届生简历模版 - 猫步简历提供的经典简历模板，适合广告传媒行业，适用于文案策划岗位，助力您的求职之路",
      "keywords": "文案策划应届生简历模版,经典简历模板,广告传媒简历,文案策划,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/template1-1753271102037.png",
      "canonicalUrl": "https://maobucv.com/template/template-104.html"
    }
  },
  {
    "id": "6882379e04c9309feaf4a14c",
    "page": "template-105.html",
    "title": "社招电商主播简历模版",
    "seo": {
      "description": "社招电商主播简历模版 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于电商运营岗位，助力您的求职之路",
      "keywords": "社招电商主播简历模版,经典简历模板,互联网通信简历,电商运营,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/Snipaste_2025-07-24_21-53-29-1753365330329.png",
      "canonicalUrl": "https://maobucv.com/template/template-105.html"
    }
  },
  {
    "id": "6888cef104c9309feaf7f1d0",
    "page": "template-106.html",
    "title": "校招银行客户经理岗位简历模板",
    "seo": {
      "description": "校招银行客户经理岗位简历模板 - 猫步简历提供的经典简历模板，适合金融投资行业，适用于客户经理岗位，助力您的求职之路",
      "keywords": "校招银行客户经理岗位简历模板,经典简历模板,金融投资简历,客户经理,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/Snipaste_2025-07-29_21-37-20-1753796328563.png",
      "canonicalUrl": "https://maobucv.com/template/template-106.html"
    }
  },
  {
    "id": "6899e05175085b2655e5696e",
    "page": "template-107.html",
    "title": "电商运营岗位简历模板",
    "seo": {
      "description": "电商运营岗位简历模板 - 猫步简历提供的简洁简历模板，适合消费运输行业，适用于物流管理岗位，助力您的求职之路",
      "keywords": "电商运营岗位简历模板,简洁简历模板,消费运输简历,物流管理,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/Snipaste_2025-08-11_20-20-02-1754914889076.png",
      "canonicalUrl": "https://maobucv.com/template/template-107.html"
    }
  },
  {
    "id": "68c173149284d8c0c01b80f8",
    "page": "template-108.html",
    "title": "校招游戏运营岗位简历模板",
    "seo": {
      "description": "校招游戏运营岗位简历模板 - 猫步简历提供的经典简历模板，适合互联网通信行业，适用于游戏运营岗位，助力您的求职之路",
      "keywords": "校招游戏运营岗位简历模板,经典简历模板,互联网通信简历,游戏运营,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/Snipaste_2025-09-10_20-44-53-1757508363638.png",
      "canonicalUrl": "https://maobucv.com/template/template-108.html"
    }
  },
  {
    "id": "69a6cd70ca365e39142c1a45",
    "page": "template-109.html",
    "title": "外贸专员-猫步简历",
    "seo": {
      "description": "外贸专员-猫步简历 - 猫步简历提供的经典简历模板，适合消费运输行业，适用于外贸专员岗位，助力您的求职之路",
      "keywords": "外贸专员-猫步简历,经典简历模板,消费运输简历,外贸专员,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/Snipaste_2026-03-03_19-57-33-1772539211342.png",
      "canonicalUrl": "https://maobucv.com/template/template-109.html"
    }
  },
  {
    "id": "69a97919fb95f2b73ade7bb8",
    "page": "template-110.html",
    "title": "3年经验行政管理简历模版",
    "seo": {
      "description": "3年经验行政管理简历模版 - 猫步简历提供的创意简历模板，适合职能支持行业，适用于行政岗位，助力您的求职之路",
      "keywords": "3年经验行政管理简历模版,创意简历模板,职能支持简历,行政,猫步简历",
      "imageUrl": "https://maobucv.com:9000/resume/createTemplate/Snipaste_2026-03-05_20-34-38-1772714259870.png",
      "canonicalUrl": "https://maobucv.com/template/template-110.html"
    }
  }
];

export default templates;